// Shared palette for the chat widget and the AI assistant panel, so the two
// surfaces can never drift apart.
export const THEME = {
  blue: "#2563eb",
  blueDark: "#1d4ed8",
  blueGrad: "linear-gradient(135deg,#3b82f6,#1d4ed8)",
  headerGrad: "linear-gradient(135deg,#1e40af,#2563eb)",
  ink: "#1e293b",
  soft: "#eef2ff",
  green: "#16a34a",
  red: "#e11d48",
  grey: "#94a3b8",
};

export default THEME;
